import { useRepositoryQuery } from '@mews-commander/data-access';

export const useCentralCancellationPolicyGet = (cancellationPolicyId?: string) =>
    useRepositoryQuery(
        'portfolioCentralCancellationPolicies',
        'get',
        {
            centralCancellationPolicyId: cancellationPolicyId ?? '',
        },
        {
            enabled: !!cancellationPolicyId,
            select: ({ centralCancellationPolicy }) => centralCancellationPolicy,
            placeholderData: (previousData) => previousData,
        }
    );
